export default "__VITE_ASSET__DbqlSvp0__"